import TransactionsGrid from '../components/Grid';
import { TransactionProvider } from '../store';

export default function TransactionsGridLayout() {
  return <TransactionProvider>
    <TransactionsGrid />
  </TransactionProvider>
}

